import React        from 'react';
import {render}     from 'react-dom';
import GlobalSearch from "../components/GlobalSearch/GlobalSearch";
import Flux         from "../flux/Flux";

function run(hook, globalSearchData) {
	const el = document.getElementById(hook);

	if (el) {
		Flux.GlobalSearch.init(globalSearchData.suggestions, globalSearchData.lastSearchRequests, globalSearchData.searchUrl);

		render(<GlobalSearch />, el);
	}

	// DO NOT UNMOUNT THIS COMPONENT ON PJAX!!!
}

export {run};